<script>
export default {
  props: {
    position: {
      type: Number,
      default: 0
    },
    direction: {
      type: String,
      default: 'x'
    }
    /* autoScroll: {
      type: Boolean,
      default: false
    } */
  },
  computed: {
    scrollPosition () {
      if (this.direction === 'x') {
        return 'scrollLeft'
      } else {
        return 'scrollTop'
      }
    }
  },
  watch: {
    position: {
      immediate: false,
      handler (value) {
        this.scrollTo(value)
      }
    }
  },
  mounted () {
    this.scrollTo(this.position)
    if (this.autoScroll) {

    }
  },
  methods: {
    scroll (to, _to) {
      const pos = this.$refs.container[this.scrollPosition]
      const dist = Math.abs((to - pos) * (1 / 6))
      if (to - pos >= 1) {
        this.$refs.container[this.scrollPosition] = pos + Math.max(dist, 1)
      } else if (to - pos <= -1) {
        this.$refs.container[this.scrollPosition] = pos - Math.max(dist, 1)
      }
      this.$emit('setPos', this.$refs.container[this.scrollPosition])
      if (Math.abs(to - this.$refs.container[this.scrollPosition]) >= 1) {
        this.timeoutId = setTimeout(() => this.scroll(to, _to), 1000 / 60)
      } else {
        this.$refs.container[this.scrollPosition] = _to
      }
    },
    scrollTo (_to) {
      clearTimeout(this.timeoutId)
      const to = _to - _to / 10000 // Androidで発生する誤差吸収
      this.scroll(to, _to)
    },
    onScroll (val) {
      this.$emit('setPos', this.$refs.container[this.scrollPosition])
    }
  }
}
</script>

<template>
  <div
    class="overflow-scroller"
    ref="root"
  >
    <div
      class="scroll-container"
      ref="container"
      :class="{
        'scroll-x': direction === 'x',
        'scroll-y': direction === 'y'
      }"
      @scroll="onScroll"
    >
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.overflow-scroller {
  overflow: hidden;
  position: relative;
  height: 100%;
  .scroll-container {
    width: 100%;
    height: 100%;
    &.scroll-x {
      overflow-x: scroll;
      overflow-y: hidden;
      @include is-not-mobile {
        height: calc(100% + 17px);
      }
    }
    &.scroll-y {
      overflow-x: hidden;
      overflow-y: scroll;
      @include is-not-mobile {
        width: calc(100% + 17px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/overflow-scroller.vue